<template>
    <div>
        <div v-if="mode=='conc'">
            <table class="table">
                <tr>
                    <th></th>
                    <th colspan="2" class="right">Positive</th>
                    <th></th>
                    <th colspan="2" class="left">Negative</th>
                </tr>
                <tr>
                    <th>Conc.(nM)</th>
                    <td class="positive">...</td>
                    <td class="positive value right">{{ parseFloat(conc[0]).toFixed(2) }}</td>
                    <td>...</td>
                    <td class="negative value left">{{ parseFloat(conc[1]).toFixed(2) }}</td>
                    <td class="negative">...</td>
                </tr>
                <tr>
                    <th>-Log</th>
                    <td class="positive">...</td>
                    <td class="positive value right">{{ parseFloat(criteria[1]).toFixed(2) }}</td>
                    <td>...</td>
                    <td class="negative value left">{{ parseFloat(criteria[0]).toFixed(2) }}</td>
                    <td class="negative">...</td>
                </tr>
            </table>
        </div>

        <div v-if="mode=='log'">
            <table class="table">
                <tr>
                    <th></th>
                    <th colspan="2" class="right">Negative</th>
                    <th></th>
                    <th colspan="2" class="left">Positive</th>
                </tr>
                <tr>
                    <th>Conc.(nM)</th>
                    <td class="negative">...</td>
                    <td class="negative value right">{{ parseFloat(conc[1]).toFixed(2) }}</td>
                    <td>...</td>
                    <td class="positive value left">{{ parseFloat(conc[0]).toFixed(2) }}</td>
                    <td class="positive">...</td>
                </tr>
                <tr>
                    <th>-Log</th>
                    <td class="negative">...</td>
                    <td class="negative value right">{{ parseFloat(criteria[0]).toFixed(2) }}</td>
                    <td>...</td>
                    <td class="positive value left">{{ parseFloat(criteria[1]).toFixed(2) }}</td>
                    <td class="positive">...</td>
                </tr>
                <tr v-if="counts">
                    <th>Count</th>
                    <td class="negative"></td>
                    <td class="negative value right">{{ counts['negative'] }}</td>
                    <td>...</td>
                    <td class="positive value left">{{ counts['positive'] }}</td>
                    <td class="positive">...</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import 'nouislider/distribute/nouislider.css';

export default {
    name: 'CriteriaTable',
    components: {
    },
    props: {
        mode: String,
        criteria: Array,
        counts: Object,
    },
    mounted() {
    },
    watch: {
    },
    computed: {
        conc: function() {
            return [
                (Math.pow(10, -1 * this.criteria[1]) * Math.pow(10, 9)).toFixed(2),
                (Math.pow(10, -1 * this.criteria[0]) * Math.pow(10, 9)).toFixed(2)
            ]
        }
    },
    methods: {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
select {
    width: 200px;
}

button {
    width: 120px;
}

.table {
    margin-left: auto;
    margin-right: auto;
}

.table .positive {
    background-color: #56d296;
}

.table .negative {
    background-color: mistyrose;
}

.table td.value {
    width: 150px;
}

.left {
    text-align: left !important;
}

.right {
    text-align: right !important;
}

</style>
